/**
 * @generated SignedSource<<f390bae62497b69a2893d47e2f8fcb4e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IsUserAlreadyExistsInput = {
  _email: string;
  clientMutationId?: string | null | undefined;
};
export type requestLinkIsUserAlreadyExistsMutation$variables = {
  input: IsUserAlreadyExistsInput;
};
export type requestLinkIsUserAlreadyExistsMutation$data = {
  readonly isUserAlreadyExists: {
    readonly boolean: boolean | null | undefined;
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type requestLinkIsUserAlreadyExistsMutation = {
  response: requestLinkIsUserAlreadyExistsMutation$data;
  variables: requestLinkIsUserAlreadyExistsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "IsUserAlreadyExistsPayload",
    "kind": "LinkedField",
    "name": "isUserAlreadyExists",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "boolean",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "requestLinkIsUserAlreadyExistsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "requestLinkIsUserAlreadyExistsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f16c36ff4fca7902745b96047d55558a",
    "id": null,
    "metadata": {},
    "name": "requestLinkIsUserAlreadyExistsMutation",
    "operationKind": "mutation",
    "text": "mutation requestLinkIsUserAlreadyExistsMutation(\n  $input: IsUserAlreadyExistsInput!\n) {\n  isUserAlreadyExists(input: $input) {\n    boolean\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "4f5d3317ccd4bc7001f9a17ff1d3869a";

export default node;
